<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <panel-title icon="mdi-file-multiple" :desc="$t('SAYFALAR.LIST.SUB_TITLE')">
          <template v-slot:title>
            <span class="mr-5">{{$t('SAYFALAR.LIST.TITLE')}}</span>
            <v-btn dark :to="`${$route.path}/sayfa-ekle`" small color="blue">
              <v-icon left>mdi-plus-circle</v-icon>{{$t('SAYFALAR.LIST.ADD_PAGE_BTN')}}
            </v-btn>
          </template>
        </panel-title>
      </v-col>
    </v-row>
    <v-row v-if="listStatus">
      <v-col>
        <v-skeleton-loader class="mb-3 elevation-1" type="list-item"></v-skeleton-loader>
        <v-skeleton-loader class="mb-3 elevation-1" type="list-item"></v-skeleton-loader>
        <v-skeleton-loader class="mb-3 elevation-1" type="list-item"></v-skeleton-loader>
        <v-skeleton-loader class="mb-3 elevation-1" type="list-item"></v-skeleton-loader>
        <v-skeleton-loader class="mb-3 elevation-1" type="list-item"></v-skeleton-loader>
      </v-col>
    </v-row>

    <v-card v-if="!listStatus" height="30" class="align-center mb-0 d-none d-lg-flex">
      <v-container fluid class="py-0">
        <v-row>
          <v-col cols="12" lg="4" class="grey--text text--darken-1 text-subtitle-2 py-0">{{$t('SAYFALAR.LIST.TABLE_FIELDS.TITLE')}}</v-col>
          <v-col cols="12" lg="2" class="grey--text text--darken-1 text-subtitle-2 py-0">{{$t('SAYFALAR.LIST.TABLE_FIELDS.AUTHOR')}}</v-col>
          <v-col cols="12" lg="2" class="grey--text text--darken-1 text-subtitle-2 py-0">{{$t('SAYFALAR.LIST.TABLE_FIELDS.DATE')}}</v-col>
          <v-col
            cols="12"
            lg="2"
            class="grey--text text--darken-1 text-subtitle-2 text-center py-0"
          >{{$t('SAYFALAR.LIST.TABLE_FIELDS.STATUS')}}</v-col>
          <v-col
            cols="12"
            lg="2"
            class="grey--text text--darken-1 text-subtitle-2 text-right py-0"
          >{{$t('SAYFALAR.LIST.TABLE_FIELDS.ACTION')}}</v-col>
        </v-row>
      </v-container>
    </v-card>

    <v-row v-if="sayfaListesi.length === 0 && !listStatus">
      <v-col lg="12" class="mt-3 py-0">
        <div>
          <v-list class="grey lighten-2 rounded-md">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title class="grey--text text--darken-1 text-center text-body-1">
                  <div>{{$t('SAYFALAR.LIST.NO_PAGES_ADDITIONAL')}}</div>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </div>
      </v-col>
    </v-row>

    <v-row v-if="sayfaListesi.length > 0">
      <v-col cols="12" class="pt-2">
        <div :key="key" v-for="(group, key) in sayfaListesi">
          <v-card :key="katKey" v-for="(kat, katKey) in group" class="mb-2">
            <div class="d-flex align-center mx-0 font-weight-light text-body-2 px-3 py-2">
              <v-container fluid class="px-0 py-0">
                <v-row>
                  <v-col cols="12" lg="4" class="d-flex align-center py-2 py-lg-0">
                    <v-icon left size="20" color="blue">mdi-file-outline</v-icon>
                    <b class="mr-1" v-show="kat.depth > 0">{{depthLine(kat.depth)}}</b>
                    <span>
                      <b>{{ kat.name }}</b>
                    </span>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="4"
                    lg="2"
                    class="d-flex align-center grey--text text--darken-2 py-1 py-lg-0"
                  >{{ kat.author }}</v-col>
                  <v-col
                    cols="12"
                    sm="4"
                    lg="2"
                    class="d-flex align-center grey--text text--darken-2 py-0"
                  >{{ dateFormat(kat.date) }}</v-col>
                  <v-col cols="12" sm="4" lg="2" class="d-flex align-center justify-end py-0">
                    <v-menu offset-y>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-if="kat.publish === 1"
                          v-on="on"
                          v-bind="attrs"
                          text
                          x-small
                          color="success"
                          class="elevation-0"
                          :loading="yayinDurumuLoading[kat.code]"
                        >
                          <v-icon small color="success" left>mdi-checkbox-blank-circle</v-icon>
                          {{$t('SAYFALAR.LIST.STATUSES.PUBLISHED')}}
                          <v-icon size="20">mdi-chevron-down</v-icon>
                        </v-btn>
                        <v-btn
                          v-else
                          v-on="on"
                          v-bind="attrs"
                          text
                          x-small
                          color="warning"
                          class="elevation-0 mr-2"
                          :loading="yayinDurumuLoading[kat.code]"
                        >
                          <v-icon small color="warning" left>mdi-checkbox-blank-circle</v-icon>
                          {{$t('SAYFALAR.LIST.STATUSES.DRAFT')}}
                          <v-icon size="20">mdi-chevron-down</v-icon>
                        </v-btn>
                      </template>
                      <v-card>
                        <v-btn
                          v-if="kat.publish === 1"
                          small
                          text
                          color="warning"
                          class="text-capitalize"
                          @click="taslakOlarakKaydet(kat.code)"
                        >
                          <v-icon small color="warning" left>mdi-file</v-icon>{{$t('SAYFALAR.LIST.ACTIONS.SET_AS_DRAFT_BTN')}}
                        </v-btn>
                        <v-btn
                          v-else
                          small
                          text
                          color="success"
                          class="text-capitalize"
                          @click="yayinaAl(kat.code)"
                        >
                          <v-icon small color="success" left>mdi-check</v-icon>{{$t('SAYFALAR.LIST.ACTIONS.SET_AS_PUBLISHED_BTN')}}
                        </v-btn>
                      </v-card>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" lg="2" class="d-flex justify-end align-center pb-0 pt-3 pt-lg-0">
                    <v-tooltip bottom color="blue white--text">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-on="on"
                          v-bind="attrs"
                          fab
                          x-small
                          color="blue lighten-5"
                          class="elevation-0 mr-2"
                          :to="`${$route.path}/sayfa-duzenle/${kat.code}`"
                        >
                          <v-icon small color="blue">mdi-pencil</v-icon>
                        </v-btn>
                      </template>
                      <span>{{$t('SAYFALAR.LIST.ACTIONS.EDIT_PAGE_BTN')}}</span>
                    </v-tooltip>
                    <v-tooltip bottom color="red white--text">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-on="on"
                          v-bind="attrs"
                          fab
                          x-small
                          color="red lighten-5"
                          class="elevation-0"
                          @click="sayfayiKaldirDialog(kat.code)"
                        >
                          <v-icon small color="red">mdi-delete</v-icon>
                        </v-btn>
                      </template>
                      <span>{{$t('SAYFALAR.LIST.ACTIONS.DELETE_PAGE_BTN')}}</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
              </v-container>
            </div>
          </v-card>
        </div>
      </v-col>
    </v-row>
    <v-dialog v-model="sayfaKaldir.dialog" max-width="500">
      <v-card>
        <v-card-title class="headline red--text text--darken-4">
          <v-icon left color="red darken-4">mdi-close-octagon</v-icon>{{$t('SAYFALAR.LIST.DELETE_PAGE_DIALOG.TITLE')}}
        </v-card-title>
        <v-card-text>{{$t('SAYFALAR.LIST.DELETE_PAGE_DIALOG.INFO_CONTENT')}}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="sayfaKaldir.dialog = false">{{$t('SAYFALAR.LIST.DELETE_PAGE_DIALOG.CANCEL_BTN')}}</v-btn>
          <v-btn
            color="green darken-1"
            text
            :loading="sayfaKaldir.loading"
            @click="sayfayiKaldir()"
          >{{ $t('SAYFALAR.LIST.DELETE_PAGE_DIALOG.YES_BTN')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import PanelTitle from "../../../components/PanelTitle.vue";
import SayfalarService from "@/services/SayfalarService.js";
import _ from "lodash";

export default {
  components: { PanelTitle },
  name: "SayfaList",
  data: () => ({
    sayfaListesi: [],
    listStatus: true,
    sayfaKaldir: {
      sayfaCode: 0,
      dialog: false,
      loading: false
    },
    yayinDurumuLoading: []
  }),
  computed: {
    ...mapGetters({
      sayfaListesiHiyerarsik: "Sayfalar/SayfaList/sayfalarGrouped"
    })
  },
  methods: {
    sayfayiKaldir() {
      const sayfaCode = this.sayfaKaldir.sayfaCode;
      this.sayfaKaldir.loading = true;
      SayfalarService.sayfaKaldir({ sayfaCode })
        .then(res => {
          if (res.status === 200) {
            this.$snotify.success(this.$t('SAYFALAR.NOTIFY.PAGE_DELETE_SUCCESS'), this.$t('PANEL.NOTIFY.SUCCESS'));
            this.sayfaKaldir.dialog = false;
            return (this.listStatus = true);
          } else {
            this.$snotify.error(res.data.errMessage, this.$t('PANEL.NOTIFY.ERROR'));
          }
        })
        .then(resolved => {
          if (resolved) {
            this.sayfaListesiniGetir();
          }
          this.sayfaKaldir.loading = false;
        });
    },
    dateFormat(date) {
      return new Intl.DateTimeFormat(this.$store.state.Language.apiLanguage, {
        dateStyle: "long",
        timeStyle: "short"
      }).format(new Date(date));
    },
    sayfayiKaldirDialog(sayfaCode) {
      this.sayfaKaldir.sayfaCode = sayfaCode;
      this.sayfaKaldir.dialog = true;
    },
    depthLine(length) {
      let lines = "";
      for (let i = 0; i < length; i++) {
        lines += "—";
      }
      return lines;
    },
    sayfaListesiniGetir() {
      this.$store.dispatch("Sayfalar/SayfaList/sayfaListesi").then(res => {
        if (res.status === 200) {
          this.listStatus = false;
          this.sayfaListesi = this.sayfaListesiHiyerarsik(res.data);
        }
      });
    },
    yayinaAl(sayfaCode) {
      this.yayinDurumuLoading[sayfaCode] = true;
      SayfalarService.yayinaAl({ sayfaCode }).then(res => {
        if (res.status === 200) {
          for (let group of this.sayfaListesi) {
            let sayfaList = _.map(group, o => {
              if (o.code === sayfaCode) {
                o.publish = 1;
              }
              return o;
            });
            group = sayfaList;
          }
        }
        this.yayinDurumuLoading[sayfaCode] = false;
      });
    },
    taslakOlarakKaydet(sayfaCode) {
      this.yayinDurumuLoading[sayfaCode] = true;
      SayfalarService.taslakOlarakKaydet({ sayfaCode }).then(res => {
        if (res.status === 200) {
          for (let group of this.sayfaListesi) {
            let sayfaList = _.map(group, o => {
              if (o.code === sayfaCode) {
                o.publish = 0;
              }
              return o;
            });
            group = sayfaList;
          }
        } else {
          this.$snotify.error(res.data.errMessage, this.$t('PANEL.NOTIFY.ERROR'));
        }
        this.yayinDurumuLoading[sayfaCode] = false;
      });
    },
    sayfaListesiDuzListe() {
      let sayfaList = [];
      for (let group of this.sayfaListesi) {
        for (let page of group) {
          sayfaList.push(page);
        }
      }
      return sayfaList;
    }
  },
  created() {
    this.sayfaListesiniGetir();
  }
};
</script>